// UK numbers are stored without their leading 0 (the API returns
// contact_number as a JS number, which can't hold one), so restore it.
export default function formatPhoneNumber(number) {
  const digits = String(number);
  return digits.startsWith("0") ? digits : `0${digits}`;
}
